/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".heading[_ngcontent-%COMP%]{padding-bottom:20px}.heading[_ngcontent-%COMP%]   *[_ngcontent-%COMP%]{display:inline}.month[_ngcontent-%COMP%]{position:absolute;top:50px;left:24px;font-weight:300}.day-of-month[_ngcontent-%COMP%]{font-weight:700;float:left}.day-of-week[_ngcontent-%COMP%]{margin-left:8px}@media (max-width:410px){.month[_ngcontent-%COMP%]{top:35px;left:13px}}\n/*# sourceMappingURL=day-dialog.component.css.map*/"];
export { styles as styles };
